// state/reducers/deliveryReducer.js
import {
  FETCH_DELIVERIES_REQUEST,
  FETCH_DELIVERIES_SUCCESS,
  FETCH_DELIVERIES_FAILURE,
  UPDATE_DELIVERY_STATUS_REQUEST,
  UPDATE_DELIVERY_STATUS_SUCCESS,
  UPDATE_DELIVERY_STATUS_FAILURE
} from '../actions/types';

const initialState = {
  deliveries: [],
  loading: false,
  error: null,
  message: '',
  updatingStatus: false,
  updateError: null,    
};

export default function deliveryReducer(state = initialState, action) {
  switch (action.type) {
      case FETCH_DELIVERIES_REQUEST:
          return { ...state, loading: true, error: null };

      case FETCH_DELIVERIES_SUCCESS:
          return {
              ...state,
              loading: false,
              deliveries: action.payload,
              message: 'Deliveries loaded successfully',
          };

      case FETCH_DELIVERIES_FAILURE:
          return {
              ...state,
              loading: false,
              error: action.payload,
              deliveries: [],
          };

      // Handling delivery status update actions
      case UPDATE_DELIVERY_STATUS_REQUEST:
          return { ...state, updatingStatus: true, updateError: null };

      case UPDATE_DELIVERY_STATUS_SUCCESS:
          return {
              ...state,
              updatingStatus: false,
              deliveries: state.deliveries.map((delivery) =>
                  delivery.delivery_id === action.payload.delivery_id
                      ? { ...delivery, status: action.payload.status }
                      : delivery
              ),
              message: 'Delivery status updated successfully',
          };

      case UPDATE_DELIVERY_STATUS_FAILURE:
          return {
              ...state,
              updatingStatus: false,
              updateError: action.payload,
          };

      default:
          return state;
  }
}
